import { render, staticRenderFns } from "./MarketingResource.vue?vue&type=template&id=69d9d858&"
import script from "./MarketingResource.vue?vue&type=script&lang=js&"
export * from "./MarketingResource.vue?vue&type=script&lang=js&"
import style0 from "./MarketingResource.vue?vue&type=style&index=0&id=69d9d858&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports